import styled from "styled-components";
import InputBase from "components/Input";

export const Text = styled.p`
  color: #fff;
  text-align: center;
`;

export const Input = styled(InputBase)``;

export const Form = styled.form`
  max-width: 400px;
  margin: auto;
`;
